import { EmptyState } from './EmptyState'
import { FeatureModal } from './FeatureModal'
import { ProductBanner } from './ProductBanner'
import { ProductCard } from './ProductCard'
import { ProductModal } from './ProductModal'
import { ProductModalExtended } from './ProductModalExtended'
import { ProductWidget } from './ProductWidget'
import { ProductWidgetPopover } from './ProductWidgetPopover'
import { UpsellAlert } from './UpsellAlert'
import { UpsellButton } from './UpsellButton'
import { UpsellGuard } from './UpsellGuard'

export const UpsellingKit = {
  ProductCard,
  ProductWidget,
  ProductWidgetPopover,
  UpsellGuard,
  UpsellButton,
  UpsellAlert,
  ProductModal,
  ProductModalExtended,
  FeatureModal,
  EmptyState,
  ProductBanner,
}
